<template>
    <MyIcons :type="type" />
  </template>
  
  <script setup name="MyIcon">
  import { createFromIconfontCN } from '@ant-design/icons-vue';
  
  const MyIcons = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_4389037_qhngm6oloye.js', // 在 iconfont.cn 上生成的脚本链接
  });

const props = defineProps({
    type: {
        type: String,
        required: true,
      },
});
  
//   export { MyIcons }; // 可选，如果需要在其他地方引用 MyIcon 组件
  </script>

  <style >
  

  </style>